<template>
<div class="content">
    <div class="row mt-3">
        <div class="col-12">
            <card class="users-card" card-body-classes="table-full-width">
                    <collapse class="faq-collapse" :multiple-active="false" >
                        <FAQComponent v-for="(src,index) in url" :key="index" :uniqueKey="index" v-bind:url="src.url" v-bind:label="src.label"  :isClose="src.isClose">  </FAQComponent>
                    </collapse>
            </card>
        </div>
    </div>
</div>
</template>
<script>
import FAQComponent from './FAQComponent.vue';
import { Collapse } from "src/components";

export default {
    components: {
        FAQComponent,
        Collapse,
    },
    data(){
        return{
            url:[],
            instance: null,
        }
    },
    created() {
        this.instance = JSON.parse(window.localStorage.getItem('instance'));
        if(this.instance.city === 'sjsr'){
            this.url = [{label:'faq.label5',url:'s3://opa/tutoriel_creation_pdf.mp4',isClose:false}]
        }
        else if(this.instance.city === 'guelph'){
            this.url = [
                { label:'faq.label6',url:'s3://opa/map.mp4',isClose:false},
                {label:'faq.label7',url:'s3://opa/projects-Page.mp4',isClose:true},
                {label:'faq.label8',url:'s3://opa/Standard-mode.mp4',isClose:true}
            ]
        }
        else if(this.instance.city === 'magog'){
            this.url = [
                {label:'faq.label13',url:'s3://opa/project-list-filters-type-manager-deadline.mp4',isClose:false},
                {label:'faq.label12',url:'s3://opa/view-project-details-from-card.mp4',isClose:true},
                {label:'faq.label9',url:'s3://opa/send-water-shutdown-notice-email.mp4',isClose:true},
                {label:'faq.label11',url:'s3://opa/street-closure-by-road-center-selection.mp4',isClose:true},
                {label:'faq.label10',url:'s3://opa/enter-project-polygon-format.mp4',isClose:true},
            ]
        }
        else{
            this.url = [
                {label:'faq.label1',url:'s3://opa/tutoriel_creation_pdf.mov',isClose:false},
                {label:'faq.label2',url:'s3://opa/tutoriel_creation_projet.mov',isClose:true},
                {label:'faq.label3',url:'s3://opa/tutoriel_rappel_projet.mov',isClose:true},
                {label:'faq.label4',url:'s3://opa/tutoriel_saisie_rapide.mov',isClose:true},
            ]
        }
    },


};
</script>